import React, { FC } from 'react';
import { Cross15PxArea } from '@kl/icons/16';
import { LocaleWithLink } from 'shared/ui/no-concat-locale';
import { useAnalytics } from '../model/tracking-context';
import {
    StyledAcceptButton,
    StyledCloseButton,
    StyledContentContainer,
    StyledCookieDialogContainer,
    StyledCookieMessage,
} from './styled';

export const RequestTrackingPermission: FC = () => {
    const { hasDecision, enableTracking, disableTracking } = useAnalytics();

    if (hasDecision) return null;

    return (
        <StyledCookieDialogContainer>
            <StyledContentContainer data-testid="cookieDialog">
                <StyledCookieMessage>
                    <LocaleWithLink
                        localizationKey="CookieDialog.text"
                        attributes={{
                            'more-information-link': {
                                target: '_blank',
                                'data-testid': 'cookieDialogLink',
                            },
                        }}
                    />
                </StyledCookieMessage>
                <StyledAcceptButton
                    testId="CookieButtonOk"
                    localizationKey="CookieDialog.button"
                    onClick={enableTracking}
                />
                <StyledCloseButton
                    iconBefore={<Cross15PxArea />}
                    mode="tertiary"
                    size="small"
                    testId="CookieButtonCancel"
                    onClick={disableTracking}
                />
            </StyledContentContainer>
        </StyledCookieDialogContainer>
    );
};
